export const SUPPORTED_MEDIA_FILE_EXTENSIONS = [
  ".3ga",
  ".webm",
  ".8svx",
  ".mts",
  ".m2ts",
  ".ts",
  ".aac",
  ".mov",
  ".ac3",
  ".mp2",
  ".aif",
  ".mp4",
  ".m4v",
  ".aiff",
  ".mxf",
  ".alac",
  ".amr",
  ".ape",
  ".au",
  ".dss",
  ".flac",
  ".flv",
  ".m4a",
  ".m4b",
  ".m4p",
  ".m4r",
  ".mp3",
  ".mpga",
  ".ogg",
  ".oga",
  ".mogg",
  ".opus",
  ".qcp",
  ".tta",
  ".voc",
  ".wav",
  ".wma",
  ".wv",
];

export const SUPPORTED_DOCUMENT_FILE_EXTENSIONS = [
  ".pdf",
  ".jpg",
  ".jpeg",
  ".png",
  ".gif",
  ".webp",
  ".bmp",
  ".tiff",
  ".tif",
  ".heic",
  ".heif",
  ".svg",
];

export const SUPPORTED_FILE_EXTENSIONS = [
  ...SUPPORTED_MEDIA_FILE_EXTENSIONS,
  ...SUPPORTED_DOCUMENT_FILE_EXTENSIONS,
];

export const isAudioOrVideo = (fileName: string) => {
  const extension = fileName.toLowerCase().split(".").pop();

  return SUPPORTED_MEDIA_FILE_EXTENSIONS.includes(`.${extension}`);
};
